

/**
 * 设置对象的属性值（可以直接指定设置深层属性的值）
 *
 * @export
 * @param {any} obj 目标对象
 * @param {any} key 目标对象的属性。可以深层：`deep1.deep2.deep3`
 * @param {any} value 值
 */
export default function deepSet(obj, key, value) {
  var deepKeys = key.split('.');
  var currentKey = deepKeys.shift();

  if (deepKeys.length === 0) {
    obj[currentKey] = value;
  } else {
    if (typeof(obj[currentKey]) !== 'object') {
      obj[currentKey] = {};
    } else {
      // 为防止state突变
      obj[currentKey] = {...obj[currentKey]};
    }

    key = deepKeys.join('.');
    deepSet(obj[currentKey], key, value);
  }
}



// WEBPACK FOOTER //
// ./src/utils/deepSet.js